import type { JSX } from 'react';

import type { WithSlotProps } from '~/components/hocs';
import { withSlot } from '~/components/hocs';

export type ElementTag =
  | 'div'
  | 'section'
  | 'span'
  | 'p'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'ul'
  | 'li'
  | 'form'
  | 'label'
  | 'input'
  | 'textarea'
  | 'button'
  | 'img'
  | 'time';
type OriginalProps<T extends ElementTag> = JSX.IntrinsicElements[T] & {
  tag: T;
};

export const Element = <T extends ElementTag>(props: OriginalProps<T>) => {
  const { tag = 'div', ...rest } = props;
  const Tag = tag;

  return <Tag {...(rest as Record<string, unknown>)} />;
};

Element.displayName = 'Element';

export type ElementProps<T extends ElementTag> = OriginalProps<T> & WithSlotProps;
export const ElementWithSlot = withSlot(Element);
